import { LoginUser } from "../../LoginUser";
import { ServiceResponse } from "../ServiceResponse";

export class AddUserResponse extends ServiceResponse {
  public UserId: number = 0;
  public UserAlreadyExists: boolean = false;
}
